import { Component, signal } from '@angular/core';
import { DefaultOrganizationService } from '@core/services';

@Component({
  selector: 'app-home-organization',
  templateUrl: './home-organization.component.html',
  styleUrl: './home-organization.component.scss',
  standalone: false,
})
export class HomeOrganizationComponent {
  organizationId = signal<number | null>(null);

  constructor(private readonly organizationService: DefaultOrganizationService) {
    this.organizationId.set(this.organizationService.getOrganizationCookie());
  }

  onChangeOrganization(id: any) {
    this.organizationId.set(id);

    this.organizationService.saveOrgnaizationCookie(id);
  }
}
